export default __webpack_public_path__ + "static/media/veqtor_oops.5fc26988.svg";